<template>
  <gd-modal class="error-modal" data-qe-id="error-modal">
    <modal-app s>
      <modal-layout>
        <modal-title>{{ $t('errorView.main.title') }}</modal-title>
        <modal-content>
          <t-text>
            <slot />
          </t-text>
          <img :src="require('@/assets/error/error_asset.png')" alt="broken cards" />
        </modal-content>
        <modal-actions>
          <t-button @click="emit('close')">{{ $t('errorView.main.button') }}</t-button>
        </modal-actions>
      </modal-layout>
    </modal-app>
  </gd-modal>
</template>

<script setup lang="ts">
const emit = defineEmits(['close'])
</script>

<style lang="less">
.error-modal {
  // .flex-center {
  //   flex: none;
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;
  //   align-content: stretch;
  //   justify-items: flex-start;
  //   align-items: center;
  // }
  img {
    max-width: 100%;
    display: block;
    margin: 2em auto;
  }
}
</style>
